import React from 'react';

import LoadingOverlay from 'react-loading-overlay';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function Loader() {
    const { loading } = useAuth();

    return (
        <LoadingOverlay
            active={loading}
            spinner
            text="Loading..."
        ></LoadingOverlay>
    );
}
